export default {
  CreditAccount1121: '1121',
};
